.header {
  top: 0;
}

.hours {
  gap: 0;
  display: grid;
}

.hour {
  padding: 4px 2px;
  color: var(--color-neutral-400);
  font-weight: var(--font-weight-semibold);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1RpbWVsaW5lL3BhcnRpYWxzIiwic291cmNlcyI6WyJUaW1lbGluZUhlYWRlci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmhlYWRlciB7XG4gIHRvcDogMDsgXG59XG5cbi5ob3VycyB7IFxuICBnYXA6IDA7IFxuICBkaXNwbGF5OiBncmlkOyBcbn1cblxuLmhvdXIgeyBcbiAgcGFkZGluZzogNHB4IDJweDtcbiAgY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtNDAwKTtcbiAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LXNlbWlib2xkKTtcbn0iXX0= */